import Cookies from 'js-cookie'

const state = {
    lang: Cookies.get('lang') || 'en'
}

const mutations = {
    SET_LANG: (state, lang) => {
        state.lang = lang,
        Cookies.set('lang', lang)
    }
}

const actions = {
    setLang({ commit }, lang) {
        commit('SET_LANG', lang)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
